import Vue from "vue"

/**
 * 读取 portal setTerminalOptionsCache 写入的终端选项
 * @returns {string[]} label 列表，如 ['1','3','4','9']
 */
export function getTerminalLabels() {
    try {
        const raw = window.sessionStorage.getItem("terminalOptions")
        if (!raw) return []
        const options = JSON.parse(raw)
        if (!Array.isArray(options)) return []
        return options.map(item => String(item.label))
    } catch (e) {
        return []
    }
}

/** terminalOptions 不含 9 时展示发布范围（雷锋网等仅含 9 的环境隐藏） */
export function shouldShowPublishScope() {
    return !getTerminalLabels().includes("9")
}

function setElementVisible(el, visible) {
    if (visible) {
        if (el.__vTerminalOriginalDisplay !== undefined) {
            el.style.display = el.__vTerminalOriginalDisplay
        } else {
            el.style.removeProperty("display")
        }
    } else {
        if (el.__vTerminalOriginalDisplay === undefined) {
            el.__vTerminalOriginalDisplay = el.style.display
        }
        el.style.display = "none"
    }
}

function applyTerminalVisibility(el, binding, expectHas) {
    const label = binding.value != null && binding.value !== "" ? String(binding.value) : ""
    if (!label) {
        setElementVisible(el, true)
        return
    }
    const exists = getTerminalLabels().includes(label)
    setElementVisible(el, expectHas ? exists : !exists)
}

function createTerminalDirective(expectHas) {
    return {
        bind(el, binding) {
            applyTerminalVisibility(el, binding, expectHas)
        },
        update(el, binding) {
            applyTerminalVisibility(el, binding, expectHas)
        },
    }
}

// v-show-has-terminal="9"  当前环境终端选项包含 9 时显示
Vue.directive("show-has-terminal", createTerminalDirective(true))

// v-show-no-has-terminal="9"  当前环境终端选项不包含 9 时显示
Vue.directive("show-no-has-terminal", createTerminalDirective(false))
